import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'

export default function StudentHomework() {
  const [homework, setHomework] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetchHomework() {
      const {
        data: { user }
      } = await supabase.auth.getUser()

      if (!user) {
        setLoading(false)
        return
      }

      const { data: acc } = await supabase
        .from('student_accounts')
        .select('student_id')
        .eq('id', user.id)
        .single()

      if (!acc) {
        setLoading(false)
        return
      }

      const { data } = await supabase
        .from('homework')
        .select('*')
        .eq('student_id', acc.student_id)
        .order('date', { ascending: false })

      setHomework(data || [])
      setLoading(false)
    }

    fetchHomework()
  }, [])

  const statusCfg = {
    done: {
      label: 'Submitted',
      cls: 'badge-success'
    },
    late: {
      label: 'Late',
      cls: 'badge-warning'
    },
    missing: {
      label: 'Not submitted',
      cls: 'badge-danger'
    },
  }

  const done = homework.filter(
    h => h.status === 'done'
  ).length

  const pct = homework.length
    ? Math.round(
        (done / homework.length) * 100
      )
    : null

  if (loading) {
    return (
      <div className="empty">
        Loading...
      </div>
    )
  }

  return (
    <div>

      {/* Mobile/desktop visibility for this page */}
      <style>{`
        .student-homework-desktop {
          display: block;
        }

        .student-homework-mobile {
          display: none;
        }

        .student-homework-card {
          background: var(--c-surface);
          border: 1px solid var(--c-border);
          border-radius: 14px;
          padding: 14px;
          margin-bottom: 10px;
          box-shadow: var(--c-shadow);
        }

        .student-homework-row {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 12px;
        }

        .student-homework-note {
          margin-top: 10px;
          padding-top: 10px;
          border-top: 1px solid var(--c-border);
        }

        .student-homework-note-label {
          font-size: 11px;
          color: var(--c-text3);
          margin-bottom: 4px;
          font-weight: 600;
        }

        .student-homework-note-text {
          font-size: 13px;
          color: var(--c-text2);
          overflow-wrap: anywhere;
          word-break: break-word;
          line-height: 1.5;
        }

        @media (max-width: 767px) {
          .student-homework-desktop {
            display: none !important;
          }

          .student-homework-mobile {
            display: block !important;
          }
        }
      `}</style>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 20,
          gap: 12
        }}
      >

        <h2
          style={{
            fontSize: 20,
            fontWeight: 500
          }}
        >
          My Homework
        </h2>

        {pct !== null && (
          <span
            className={`badge ${
              pct >= 80
                ? 'badge-success'
                : pct >= 60
                  ? 'badge-warning'
                  : 'badge-danger'
            }`}
            style={{
              fontSize: 14,
              padding: '5px 14px',
              flexShrink: 0
            }}
          >
            {done}/{homework.length} Submitted
          </span>
        )}

      </div>

      {homework.length === 0 ? (
        <div className="empty">
          No homework records
        </div>
      ) : (
        <>

          {/* ================= DESKTOP ================= */}
          <div className="student-homework-desktop">

            <div
              className="card"
              style={{
                padding: 0,
                overflow: 'hidden'
              }}
            >

              <table>

                <thead>
                  <tr>
                    <th>Homework</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Note</th>
                  </tr>
                </thead>

                <tbody>

                  {homework.map(h => (

                    <tr key={h.id}>

                      <td
                        style={{
                          fontWeight: 500
                        }}
                      >
                        {h.title}
                      </td>

                      <td
                        style={{
                          color: 'var(--text3)'
                        }}
                      >
                        {h.date}
                      </td>

                      <td>

                        <span
                          className={`badge ${
                            statusCfg[h.status]?.cls ||
                            'badge-warning'
                          }`}
                        >
                          {statusCfg[h.status]?.label ||
                            h.status}
                        </span>

                      </td>

                      <td
                        style={{
                          color: 'var(--text3)',
                          maxWidth: 350,
                          overflowWrap: 'anywhere'
                        }}
                      >
                        {h.note || '—'}
                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>

          {/* ================= MOBILE ================= */}
          <div className="student-homework-mobile">

            {homework.map(h => (

              <div
                key={h.id}
                className="student-homework-card"
              >

                <div className="student-homework-row">

                  <div
                    style={{
                      minWidth: 0,
                      flex: 1
                    }}
                  >

                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 15,
                        overflowWrap: 'anywhere'
                      }}
                    >
                      {h.title}
                    </div>

                    <div
                      style={{
                        fontSize: 12,
                        color: 'var(--text3)',
                        marginTop: 4
                      }}
                    >
                      {h.date}
                    </div>

                  </div>

                  <span
                    className={`badge ${
                      statusCfg[h.status]?.cls ||
                      'badge-warning'
                    }`}
                    style={{
                      flexShrink: 0
                    }}
                  >
                    {statusCfg[h.status]?.label ||
                      h.status}
                  </span>

                </div>

                {/* NOTE */}
                <div className="student-homework-note">

                  <div className="student-homework-note-label">
                    Note
                  </div>

                  <div className="student-homework-note-text">
                    {h.note || '—'}
                  </div>

                </div>

              </div>

            ))}

          </div>

        </>
      )}

    </div>
  )
}